import { H3Event, getCookie, getRequestHeaders } from "h3";
import Logger from "../logger";
import { useRuntimeConfig } from "#imports";

const parseH3EventProperties = (event: H3Event): Record<string, unknown> => {
  const context = event.context;
  const headers = getRequestHeaders(event);

  return {
    route: context.matchedRoute?.path,
    method: event.method,
    host: headers.host,
    dbe_session_id: getCookie(event, "dbe.session_id"),
  };
};

export const useLogger = (params?: H3Event): Logger => {
  const config = useRuntimeConfig();
  const logger = Logger.getInstance({
    enabled: config.public.logger.enabled,
    singleLine: config.public.logger.singleLine,
    output: config.public.logger.output === "file" ? "file" : "pretty",
  });

  if (import.meta.server && params instanceof H3Event) {
    logger.addProperties(parseH3EventProperties(params));
  }

  return logger;
};
